export const group_actionType = {
  GET_GROUP_SUCCESS: "GET_GROUP_SUCCESS",
  GET_GROUP_FAILURE: "GET_GROUP_FAILURE",
  EDIT_REQUEST_START: "EDIT_REQUEST_START",
  EDIT_REQUEST_SUCCESS: "EDIT_REQUEST_SUCCESS",
  EDIT_REQUEST_FAILURE: "EDIT_REQUEST_FAILURE",
  SET_LOADER: "SET_LOADER",
  RESET_LOADER: "RESET_LOADER"
};
